export type SigninFormData = {
  email?: string;
  password?: string;
};

export type SignupFormData = SigninFormData & {
  name?: string;
  new_email?: string;
  coupon_code?: string;
  partner_id?: string;
  country?: string;
  enable_data_enrichment?: boolean;
  version?: number;
  url?: number;
  phone?: string;
};

export type SigninMfaFormData = {
  mfa_token: string;
  mfa_challenge?: string;
};

export enum FormStates {
  Default = 'DEFAULT',
  Requesting = 'REQUESTING',
  Success = 'SUCCESS',
  Error = 'ERROR',
}

export enum FormMessageType {
  Success = 'success',
  Error = 'error',
}

export enum PhoneType {
  MOBILE = 1,
  TOLL_FREE = 2,
}
